import "./manageusers.css";
import DataTable from 'react-data-table-component';
import { Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { FaUpload } from 'react-icons/fa';
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
import toast from "react-hot-toast";


const MySwal = withReactContent(Swal);

const ManageProjectDataUpload = () => {
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const columns = [
    {
      name: 'Items Name',
      selector: row => row.projectName,
      sortable: true,
      wrap: true
    },
    {
      name: 'Upload Data',
      selector: row => <FaUpload onClick={handleNavigate}/>,
      sortable: true,
      wrap: true,
    },
    
  ];

  const handleNavigate=()=>{
    navigate("/manageitemupdateddata")
  }
  const homepageNavigate =()=>{
    navigate("/piechart")
  }


  useEffect(() => {
    const dummyData = [
      { id: 1, projectName: 'Project A', status: 'Active' },
      { id: 2, projectName: 'Project B', status: 'Inactive' },
      { id: 3, projectName: 'Project C', status: 'Active' },
    ];
    setTableData(dummyData);
  }, []);


  const filteredData = tableData.filter(item =>
    item.projectName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className='manageUsers'>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <h3 style={{ fontSize: "20px" }}>Uploaded Items</h3>
        </div>
        
        <div style={{display:"flex", gap:"15px"}}>
          <h3 style={{ fontSize: "15px", color: "rgb(208, 38, 38)", cursor: "pointer", border:"1px solid red", padding:"7px", background:"red", color:"white" }} onClick={homepageNavigate}>+Homepage data</h3>
          <h3 style={{ fontSize: "15px", color: "rgb(208, 38, 38)", cursor: "pointer",  border:"1px solid red", padding:"7px", background:"red", color:"white" }} onClick={()=>navigate("/wbs")}>+Wbs data</h3>
        </div>
      </div>

      <div className='userSearc'></div>

      <div className="userSelector" style={{ marginTop: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <label htmlFor="selectorInput"><b>Show</b></label>&ensp;
            <select id="selectorInput" style={{ width: "65px" }}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
            </select>&ensp;
            entries
          </div>

          <div>
            <label htmlFor="searchInput"><b>Search: </b></label>&ensp;
            <input
              id="searchInput"
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </div>

      <DataTable
        className="dataTableContainer"
        columns={columns}
        data={filteredData}
        pagination={true}
        highlightOnHover
        striped
        noHeader={true}
        customStyles={{
          table: {
            style: {
              minHeight: '350px',
              maxHeight: '500px',
            },
          },
          headCells: {
            style: {
              whiteSpace: 'normal',
            },
          },
        }}
      />

      <footer style={{ position: "fixed", bottom: "0", width: "100%", padding: "10px 0", zIndex: "1", backgroundColor: "#fff" }}>
        <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ManageProjectDataUpload;
